import { graphql } from "msw";

//Takes params the entity type eg. WA
export const handlers = [
  graphql.query("getInitialTransitions", (req, res, ctx) => {
    const { entityType } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        getInitialTransitions: [
          {
            name: {
              en: "SaveAsDraft",
            },
            toStateCode: "Draft",
            allowComments: false,
          },
          {
            name: {
              en: "Submit",
            },
            toStateCode: "Submitted",
            allowComments: false,
          },
        ],
      })
    );
  }),

  //takes params: entity type kai entity id
  graphql.query("getEntityTransitions", (req, res, ctx) => {
    const { entityType, entityId } = req.variables; // eslint-disable-line no-unused-vars
    return res(
      ctx.data({
        getEntityTransitions: [
          {
            name: {
              en: "Delete",
            },
            fromStateCode: "Draft",
            toStateCode: "Deleted",
            allowComments: false,
          },
          {
            name: {
              en: "Submit WA",
            },
            fromStateCode: "Draft",
            toStateCode: "Submitted",
            allowComments: false,
          },
        ],
      })
    );
  }),
];
